import { useRelatedProducts } from '../hooks/useRelatedProducts';

type ContentContainerProps = {
	children: React.ReactNode;
};

const ContentContainer = ({ children }: ContentContainerProps) => {
	const { blockClass } = useRelatedProducts();

	const renderClass = () => blockClass && `vtex-shelf-1-x-shelfContentContainer--${blockClass}`;

	return <div className={`vtex-shelf-1-x-shelfContentContainer ${renderClass()} flex justify-center`}>{children}</div>;
};

export default ContentContainer;
